module.exports = __webpack_public_path__ + "assets/img/logo-auc.6caa2f10.svg";